import { defineMessages } from 'react-intl-next';

export const messages: {
	backgroundColorLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	backgroundColorLabel: {
		id: 'company-hub.card-extensions.card-config.background-color-field.title',
		defaultMessage: 'Background color',
		description:
			'A visible text label for the cards background color section of the link cards config panel that informs the user that they can change the background color of the card.',
	},
});
